export default "__VITE_PUBLIC_ASSET__aa4c4ac0__"